import type Konva from "konva";

export type Bounds = { x: number; y: number; width: number; height: number };

export function metadataNodes(stage: Konva.Stage): Konva.Node[] {
  return stage.findOne<Konva.Group>(".metadata-text")?.getChildren() ?? [];
}

export function unionBounds(bounds: Bounds[]): Bounds | null {
  if (!bounds.length) return null;
  const x = Math.min(...bounds.map((rect) => rect.x));
  const y = Math.min(...bounds.map((rect) => rect.y));
  const right = Math.max(...bounds.map((rect) => rect.x + rect.width));
  const bottom = Math.max(...bounds.map((rect) => rect.y + rect.height));
  return { x, y, width: right - x, height: bottom - y };
}

export function dayBounds(stage: Konva.Stage, day: string) {
  const children = metadataNodes(stage).filter(
    (node) => node.getAttr("metadataDay") === day && node.getClientRect().width > 0,
  );
  return unionBounds(children.map((node) => node.getClientRect({ relativeTo: stage })));
}

export function metadataBounds(node: Konva.Node): Bounds {
  const stage = node.getStage()!;
  const path = node.getAttr("metadataPath") as string | undefined;
  if (path?.endsWith(".origin")) {
    const bounds = dayBounds(stage, node.getAttr("metadataDay"));
    if (bounds) return bounds;
  }
  return node.getClientRect({ relativeTo: stage });
}
